import { render, staticRenderFns } from "./notificationBoard.vue?vue&type=template&id=03535a4e&scoped=true"
import script from "./notificationBoard.vue?vue&type=script&lang=js"
export * from "./notificationBoard.vue?vue&type=script&lang=js"
import style0 from "./notificationBoard.vue?vue&type=style&index=0&id=03535a4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03535a4e",
  null
  
)

export default component.exports